export default {
  REGISTER_USER_COMMAND_SERVICE: Symbol.for('REGISTER_USER_COMMAND_SERVICE'),
  USER_REPOSITORY: Symbol.for('USER_REPOSITORY'),
};
